import { injectable, inject } from 'inversify';
import { SuspendDataStore, SuspendDataStoreSymbol, SuspendDataStateStore } from '@/app/tracking/common';
import { sectionStateReducer, SectionCommand, SectionStates } from './section-state-reducer';
import { SectionState, defaultSectionState } from './section-state';

interface SectionsSuspendData {
  sections: SectionStates;
}

@injectable()
export class SectionSuspendDataStateStore {

  private store: SuspendDataStateStore<SectionState, unknown, SectionCommand>;

  constructor(
    @inject(SuspendDataStoreSymbol)
    suspendDataStore: SuspendDataStore<SectionsSuspendData>) {

    this.store = new SuspendDataStateStore(
      () => suspendDataStore.get2('sections'),
      (data: SectionState[]) => suspendDataStore.update2('sections', data),
      (id) => defaultSectionState(id),
      sectionStateReducer);
  }

  public async query(ids: string[] | 'all') {
    return this.store.query(ids);
  }

  public async execute(command: SectionCommand) {
    await this.store.execute(command);
  }
}
